"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _uuid = require("uuid");
var _createHash = _interopRequireDefault(require("create-hash"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _WorkflowAPI = require("./WorkflowAPI");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Workflow = _ref => {
  var _workflowContext$step, _workflowContext$step2, _workflowContext$step3;
  let {
    workflowUrl,
    failureUrl = '/',
    failureCallback = null,
    completeCallback = null,
    initializationContent = null,
    initializeMethod = (apiUrl, formData) => (0, _WorkflowAPI.initializeWorkflow)(apiUrl, formData),
    continueMethod = (apiUrl, formData) => (0, _WorkflowAPI.continueWorkflow)(apiUrl, formData),
    backMethod = (apiUrl, formData) => (0, _WorkflowAPI.backWorkflow)(apiUrl, formData),
    componentLoader,
    header = '',
    footer = '',
    title = '',
    showButtons = true,
    showCancelButton = false,
    showBackButton = false,
    autoInitiate = true,
    ...props
  } = _ref;
  const [codeVerifier, setCodeVerifier] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(autoInitiate);
  const [initialPageLoadComplete, setInitialPageLoadComplete] = (0, _react.useState)(false);
  const [componentSettings, setComponentSettings] = (0, _react.useState)({
    nextButtonTitle: 'Next',
    nextButtonDisabled: false,
    nextButtonTitleLoaded: false
  });
  const [workflowContext, setWorkflowContext] = (0, _react.useState)({
    errorModalKey: (0, _uuid.v4)(),
    successModalKey: (0, _uuid.v4)(),
    contextId: null,
    component: null,
    stepResponse: null
  });
  const contentRef = (0, _react.useRef)();
  const initialize = workflowUrlArg => {
    const currentChallengeUUID = (0, _uuid.v4)();
    const codeVerifierTemp = (0, _createHash.default)('sha256').update(currentChallengeUUID).digest('base64');
    setCodeVerifier(codeVerifierTemp);
    const formData = new FormData();
    formData.append('client_id', _ApplicationContext.ApplicationContext.getClientId());
    formData.append('code_challenge', currentChallengeUUID);
    formData.append('code_challenge_method', 'S256');
    initializeMethod(workflowUrlArg, formData).then(results => {
      setWorkflowContext(priorContext => {
        var _results$data;
        return {
          ...priorContext,
          contextId: results.data.contextId,
          errorModalKey: (0, _uuid.v4)(),
          successModalKey: (0, _uuid.v4)(),
          component: ((_results$data = results.data) === null || _results$data === void 0 ? void 0 : _results$data.stepStatus) === 'SUCCESS' ? results.data.nextStep : null,
          stepResponse: results.data
        };
      });
      setLoading(false);
    }).catch(e => {
      console.log(e);
      setWorkflowContext(priorContext => ({
        ...priorContext,
        stepResponse: {
          message: 'Unable to initialize processing at this time.  Please try again later.',
          stepStatus: 'FAILED',
          workflowStatus: 'FAILED'
        }
      }));
      setLoading(false);
    });
  };
  const cancel = () => {
    props.history.push(failureUrl);
  };
  const proceed = function (step) {
    let isNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (contentRef.current) {
      contentRef.current.setLoading(true);
    }
    step.setCodeVerifier(codeVerifier);
    step.setContextId(workflowContext.contextId);
    let wfPromise = continueMethod;
    if (!isNext) {
      wfPromise = backMethod;
    }
    wfPromise(workflowUrl, step).then(results => {
      setWorkflowContext(priorContext => {
        var _results$data2;
        return {
          ...priorContext,
          contextId: results.data.contextId,
          errorModalKey: (0, _uuid.v4)(),
          successModalKey: (0, _uuid.v4)(),
          component: ((_results$data2 = results.data) === null || _results$data2 === void 0 ? void 0 : _results$data2.nextStep) && results.data.nextStep,
          stepResponse: results.data
        };
      });
      if (contentRef.current) {
        contentRef.current.setLoading(false);
      }
    }).catch(error => {
      let message = 'Unable to process at this time.  Please try again later.';
      if (error.response.data.status === 400 && error.response.data.errors && error.response.data.errors.length > 0 && error.response.data.errors[0] === 'The specified workflow is not active') {
        message = "We're sorry, but too much time has ellapsed and you will need to start the process again";
      }
      const stepResponse = {
        ...workflowContext.stepResponse,
        message,
        stepStatus: 'FAILED',
        workflowStatus: 'FAILED'
      };
      setWorkflowContext(priorContext => ({
        ...priorContext,
        errorModalKey: (0, _uuid.v4)(),
        successModalKey: (0, _uuid.v4)(),
        stepResponse
      }));
      if (contentRef.current) {
        contentRef.current.setLoading(false);
      }
    });
  };
  const next = () => {
    const step = contentRef.current.getStep();
    if (!step) {
      return;
    }
    proceed(step);
  };
  const back = () => {
    const step = contentRef.current.getStep();
    if (!step) {
      return;
    }
    proceed(step, false);
  };
  const setNextDisabled = _react.default.useCallback(isDisabled => {
    setComponentSettings(prevSettings => ({
      ...prevSettings,
      nextButtonDisabled: isDisabled
    }));
  });
  (0, _react.useEffect)(() => {
    if (autoInitiate) {
      initialize(workflowUrl);
    }
    setInitialPageLoadComplete(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (contentRef.current) {
      setComponentSettings(prevSettings => ({
        ...prevSettings,
        nextButtonTitle: contentRef.current.getNextButtonTitle(),
        nextButtonTitleLoaded: true
      }));
    } else {
      setComponentSettings(prevSettings => ({
        ...prevSettings,
        nextButtonTitleLoaded: false
      }));
    }
  }, [workflowContext]);
  const handleFailure = () => {
    if (failureCallback) {
      failureCallback(workflowContext.stepResponse);
      return;
    }
    cancel();
  };
  const handleModalClose = () => {
    if (workflowContext.stepResponse.messageUrl) {
      props.history.push(workflowContext.stepResponse.messageUrl);
    } else if (workflowContext.stepResponse.workflowStatus === 'FAILED') {
      handleFailure();
    }
  };
  let isWorkflowFailure = false;
  let icon = 'warning';
  let msgClass = 'has-text-warning';
  const errorTitle = 'Unable to Process Request';
  let errorMessage = '';
  if ((workflowContext === null || workflowContext === void 0 || (_workflowContext$step = workflowContext.stepResponse) === null || _workflowContext$step === void 0 ? void 0 : _workflowContext$step.workflowStatus) === 'FAILED') {
    isWorkflowFailure = true;
    icon = 'error';
    msgClass = 'has-text-danger';
    errorMessage = workflowContext.stepResponse.message;
  } else if ((workflowContext === null || workflowContext === void 0 || (_workflowContext$step2 = workflowContext.stepResponse) === null || _workflowContext$step2 === void 0 ? void 0 : _workflowContext$step2.stepStatus) === 'FAILED') {
    errorMessage = workflowContext.stepResponse.message;
  }
  const errorMessageFormatted = /*#__PURE__*/_react.default.createElement("div", {
    className: "columns is-mobile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `column is-1 icon is-right ${msgClass}`
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons is-size-1"
  }, icon)), /*#__PURE__*/_react.default.createElement("div", {
    className: "column is-11 ",
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  }));
  let workflowCompleteMessage = '';
  if ((workflowContext === null || workflowContext === void 0 || (_workflowContext$step3 = workflowContext.stepResponse) === null || _workflowContext$step3 === void 0 ? void 0 : _workflowContext$step3.workflowStatus) === 'COMPLETE') {
    if (completeCallback) {
      completeCallback(workflowContext.stepResponse);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    workflowCompleteMessage = /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-1 icon is-right has-text-success"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-1"
    }, "done")), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-11 ",
      dangerouslySetInnerHTML: {
        __html: workflowContext.stepResponse.message
      }
    }));
  }
  let content = '';
  if (autoInitiate && workflowContext.contextId) {
    content = componentLoader(workflowContext.component, setNextDisabled, proceed, workflowContext.stepResponse, contentRef, props);
  } else if (initializationContent) {
    content = initializationContent;
  } else if (initialPageLoadComplete && !loading) {
    content = /*#__PURE__*/_react.default.createElement("article", {
      className: "message is-danger"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "message-body"
    }, "The workflow must be initialized in order to continue;"));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "workflow-container my-2"
  }, header, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: ""
  }, title, /*#__PURE__*/_react.default.createElement("div", {
    className: `lds-spinner-overlay ${loading && 'is-active'}`
  }, loading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement(_core.OkModal, {
    header: errorTitle,
    message: errorMessageFormatted,
    display: errorMessage !== '',
    closeModalCallback: () => {
      handleModalClose();
    },
    key: workflowContext.errorModalKey
  }), /*#__PURE__*/_react.default.createElement(_core.OkModal, {
    header: 'Success!',
    message: workflowCompleteMessage,
    display: workflowCompleteMessage !== '',
    closeModalCallback: () => {
      cancel();
    },
    key: workflowContext.successModalKey
  }), content), !isWorkflowFailure && showButtons && componentSettings.nextButtonTitleLoaded && /*#__PURE__*/_react.default.createElement("div", {
    className: "m-2"
  }, showCancelButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "is-primary fixedButtonSize",
    handleClick: cancel
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "is-primary is-pulled-right fixedButtonSize",
    handleClick: next,
    disabled: componentSettings.nextButtonDisabled
  }, componentSettings.nextButtonTitle), showBackButton && /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "is-primary is-pulled-right fixedButtonSize mr-4",
    handleClick: back
  }, "Back")), footer);
};
Workflow.propTypes = {
  workflowUrl: _propTypes.default.string,
  failureUrl: _propTypes.default.string,
  failureCallback: _propTypes.default.func,
  completeCallback: _propTypes.default.func,
  initializationContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  initializeMethod: _propTypes.default.func,
  continueMethod: _propTypes.default.func,
  backMethod: _propTypes.default.func,
  componentLoader: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func, _propTypes.default.string]),
  header: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  showButtons: _propTypes.default.bool,
  showCancelButton: _propTypes.default.bool,
  showBackButton: _propTypes.default.bool,
  autoInitiate: _propTypes.default.bool,
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Workflow);
//# sourceMappingURL=Workflow.js.map